import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DriverSelectionAlgorithm } from '../../shared/project/cards/driver-selection-algorithm';

export interface RelatedCardsSettingsModalData {
    selectedAlgorithm: DriverSelectionAlgorithm;
    outcomeName: string;
}

@Component({
  selector: 'related-cards-settings-modal',
  templateUrl: './related-cards-settings-modal.component.html',
  styleUrls: ['../../import/general.scss', './related-cards-settings-modal.component.scss']
})
export class RelatedCardsSettingsModalComponent {
    public selectedAlgorithm: DriverSelectionAlgorithm;
    public outcomeName: string;
    public DriverSelectionAlgorithm = DriverSelectionAlgorithm;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: RelatedCardsSettingsModalData,
        private dialogRef: MatDialogRef<RelatedCardsSettingsModalComponent>
    ) {
        this.selectedAlgorithm = data.selectedAlgorithm;
        this.outcomeName = data.outcomeName;
    }

    public save(): void {
        this.dialogRef.close(this.selectedAlgorithm);
    }

    public cancel(): void {
        this.dialogRef.close();
    }
}
